<script lang="ts">
  import { onMount } from 'svelte';
  import KeyboardHint from '$icons/KeyboardHintIcon.svelte';
  import Modal from '$lib/components/Modals/SmallModal/Modal.svelte';
  import Ranking from '$icons/RankingIcon.svelte';
  import DateRange from '../common/dropdowns/DateRange.svelte';
  import SearchIconLeft from '../common/dropdowns/TextInputWithSearchIconLeft.svelte';
  import { getAllSubcategories } from '$src/utils/api/subcategories.util';
  import { selectedSubCategory } from '$stores/posts.store';
  import { fetchedCategoryStrings } from '$src/stores/categories.store';
  import Button from '../common/buttons/Button.svelte';
  import type { ISubCategory } from 'garden-common';

  export let performanceRangeStart: Date = null;
  export let performanceRangeEnd: Date = null;
  export let category: string = null;

  let allCategories: string[] = null;
  let subcategories: ISubCategory[];

  onMount(async () => {
    subcategories = await getAllSubcategories(50);

    allCategories = subcategories.map(i => `${i.name}/${i.categoryName}`);
    fetchedCategoryStrings.set(
      subcategories.map(i => {
        return { _id: i._id, data: `${i.name}/${i.categoryName}` };
      })
    );
  });
</script>

{#if allCategories}
  <Modal on:ModalClose class="w-[550px] sh-[656px]" footerBorder>
    <div slot="content" class="flex flex-col items-center w-full gap-8 mt-20 mb-6">
      <div class="flex flex-col items-center gap-3">
        <Ranking />
        <h1 class="font-bold text-2xl">Describe your performance</h1>
        <sub class="text-garden-grey-600 font-normal text-sm w-80 text-center"
          >Help us make your upload faster and genuine by filling in the details about your
          performance.</sub
        >
      </div>
      <div class="w-full h-full flex flex-col gap-4">
        <DateRange
          label="Performance took place in"
          caption=""
          bind:startDate={performanceRangeStart}
          bind:endDate={performanceRangeEnd}
        />
        <SearchIconLeft
          label="My performance falls under"
          caption=""
          bind:value={category}
          placeholder="Search talent"
          options={allCategories}
          createNewDisable
        />
      </div>
    </div>
    <div slot="footer" class="flex flex-row justify-end gap-2 pt-4" data-sveltekit-reload>
      <!--<ButtonSecondaryIconLeft label="Upload via link">
				<Link />
			</ButtonSecondaryIconLeft>-->
      <Button label="Close" secondary>
        <div slot="icon-right">
          <KeyboardHint type="escape" />
        </div>
      </Button>
      <a
        href={`/create-post?s=${performanceRangeStart?.toISOString()}&e=${performanceRangeEnd?.toISOString()}&category=${category}`}
      >
        <Button
          primary
          label="Add details"
          disabled={performanceRangeStart === null ||
            performanceRangeEnd === null ||
            category === null ||
            !allCategories.includes(category)}
          on:click={() => {
            // temp
            selectedSubCategory.set(
              subcategories.find(s => `${s.name}/${s.categoryName}` === category)
            );

            // goto(
            // 	`/create-post?s=${performanceRangeStart.toISOString()}&e=${performanceRangeEnd.toISOString()}&category=${category}`
            // );
          }} /></a
      >
    </div>
  </Modal>
{/if}
